<template>
    <div class="market-accordion-container">
        <accordion :items="block.market_categories" class="blue">
            <template v-slot:accordion-selector-title="{item}">
                <span v-html="item.market_category_name"></span>
            </template>
            <template v-slot:accordion-item-header-title="{item}">
                <div class="title" v-html="item.market_category_name"></div>
                <div class="expanded-title">
                    <a v-if="item.market_category_button.title != null" class="btn" :href="item.market_category_button.url" :target="item.market_category_button.target"><span v-html="item.market_category_button.title"></span> <i class="fas fa-chevron-right"></i></a>
                    <div class="title" v-else v-html="item.market_category_name"></div>
                </div>
            </template>
            <template v-slot:accordion-item-content="{item}">
                <div class="market" v-for="(subMarket, index) in item.subcategory" :key="index">
                    <div class="container">
                        <div class="flex">
                            <div class="primary" :style="`background-image: url(${subMarket.primary_image.url});`">
                                <h2 class="title" v-html="subMarket.subcategory_name"></h2>
                            </div>
                            <div class="secondary bg-white" :class="{'with-case-study': subMarket.show_related_case_studies }">
                                <div class="row top">
                                    <div class="content">
                                        <div class="top-title" v-html="subMarket.content.top_title"></div>
                                        <h2 class="title" v-html="subMarket.content.title"></h2>
                                        <div class="copy" v-html="subMarket.content.copy"></div>
                                        <a v-if="subMarket.content.button" class="btn hover-button bright-blue" :href="subMarket.content.button.url" :target="subMarket.content.button.target" v-html="subMarket.content.button.title"></a>
                                    </div>
                                </div>
                                <div class="row case-study-row" v-if="subMarket.show_related_case_studies">
                                    <div class="carousel-container">
                                        <slick-carousel class="case-study-carousel" :options="getCaseStudyCarouselOptions()">
                                            <div class="case-study" v-for="(caseStudy, index) in subMarket.case_studies" :key="index">
                                                <div class="flex">
                                                    <div class="image">
                                                        <img :src="caseStudy.acf_fields.feature_settings.primary_image.url">
                                                    </div>
                                                    <div class="content bg-light-gray">
                                                        <div class="top-title">Case Study</div>
                                                        <h2 class="title" v-html="caseStudy.post_title"></h2>
                                                        <div class="button-container">
                                                            <a class="hover-button orange" :href="caseStudy.permalink">Continue reading</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </slick-carousel>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="divider"></div>
                    </div>
                </div>
            </template>
        </accordion>
    </div>
</template>

<script>
export default {
    props: {
        block: {
            type: Object,
            required: true
        }
    },
    mounted() {},
    methods: {
        getCaseStudyCarouselOptions() {
            return {
                'slidesToShow': 1,
                'slidesToScroll': 1,
                'nextArrow': '<div class="arrow-container"><i class="slick-arrow top right fas fa-chevron-right"></i><i class="slick-arrow bottom right fas fa-chevron-right"></i></div>',
                'prevArrow': '',
                'touchThreshold': 100,
                'variableWidth': false,
                'infinite': true
            }
        }
    }
}
</script>